<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="30%"
            height="100%"
            no-click-animation
            >
            <v-card class="pa-3">
                <CardTitle :title="page_title" />
                <v-data-table
                    :headers="headers"
                    :items="desserts"
                    hide-default-footer
                    class="elevation-1"
                    >
                    <template v-slot:top>
                        <v-toolbar flat color="white" class="mt-1">
                            <div class="flex-grow-1">{{ propsBenefitGolfName }}</div>
                            <div class="flex-grow-1">{{ propsBenefitPlanName }}</div>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.btn`]="{ item }">
                        <v-btn
                            :disabled="btn[1].isActive"
                            @click="displayRemoveOverLay(item)
                            ">削除</v-btn>
                    </template>
                </v-data-table>
                <v-pagination
                    class="my-2"
                    v-model="page"
                    :length="pageCount"
                    :total-visible="7"
                    @input="clickPagination"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-4" text @click="closeModal">閉じる</v-btn>
                    <v-btn
                        :disabled="btn[2].isActive"
                        color="green darken-4"
                        text
                        @click="openChild">追加</v-btn>
                </v-card-actions>
                <RemoveOverLay
                    page-name="特典"
                    @processing="deletePlanBenefit"
                    @cancel="closeRemoveOverLay"
                    :process-result="process"
                    :overlay-switch="removeOverlay"
                />
            </v-card>
        </v-dialog>
        <PlanBenefit
            :ID="benefitCd"
            :propsPlanId="propsBenefitPlanId"
            :propsPlanName="propsBenefitPlanName"
            :dialog="benefitDialog"
            :displayGolfCourse="propsBenefitGolfCourse"
            :displayGolfCourseName="propsBenefitGolfName"
            @close="closeChild"
        />
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
// モーダル
import PlanBenefit from './PlanBenefit';
import RemoveOverLay from '@/components/overlay/RemoveOverlay';
// graghql
import {
    GET_PLAN_BENEFIT_LIST,
    DELETE_PLAN_BENEFIT } from '@/constants/plan';

export default {
    components: {
        CardTitle,
        PlanBenefit,
        RemoveOverLay
    },
    props: [
        'dialog',
        'propsBenefitAdmin',
        'benefitGolfCourse',
        'propsBenefitGolfName',
        'propsBenefitPlanId',
        'propsBenefitPlanName'
    ],
    data () {
        return {
            // 削除確認用ポップアップ表示に関する制御値
            removeOverlay: false,
            // 登録画面の表示値
            benefitDialog: false,
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: 'No', value: 'benefit_cd' },
                { text: '特典', value: 'benefit_name', align: 'center', sortable: false },
                { text: '', align: 'center', value: 'btn', sortable: false, width: '150' }
            ],
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '特典設定一覧',
            // 削除ID
            benefitCd: '',
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '削除', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true }
            ],
            vue_id: 'SCR0026',
            page: 1,
            pageCount: 0,
            // offset
            beginRow: 0,
            // 一覧の最大表示値
            limitRows: 10,
            // 特典データのカウント
            count: 0,
            propsBenefitGolfCourse: ''
        };
    },
    watch: {
        // 親からデータが渡ってきたときに発火
        async propsBenefitPlanId () {
            if (this.propsBenefitPlanId !== '') {
                this.getBenefitList();
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * プランに紐づく特典を取得
         * 発火タイミングはwatchで処理
         * ---------------------------------------------- */
        getBenefitList () {
            this.$apollo.mutate({
                mutation: GET_PLAN_BENEFIT_LIST,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    plan_id: this.propsBenefitPlanId,
                    limit: this.limitRows,
                    offset: this.beginRow,
                    user_id: this.propsBenefitAdmin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                const data = res.data.getBenefitList.PlanBenefitList;
                this.count = res.data.getBenefitList.count;
                this.pageCount = Math.ceil(this.count / this.limitRows);
                this.desserts.splice(0, this.desserts.length);
                data.forEach(res => {
                    this.desserts.push(res);
                });
                let opeList = res.data.getBenefitList.OperationAccessList;
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                        }
                    });
                };
            });
        },
        /** ----------------------------------------------
         * 削除処理
         * ---------------------------------------------- */
        deletePlanBenefit () {
            this.$apollo.mutate({
                mutation: DELETE_PLAN_BENEFIT,
                variables: {
                    plan_id: this.propsBenefitPlanId,
                    benefit_cd: this.benefitCd
                }
            }).then(res => {
                const data = res.data.deletePlanBenefit.result;
                if (data === 1) {
                    this.getBenefitList();
                    this.closeRemoveOverLay();
                } else {
                    throw new Error('エラーが発生しました。');
                }
            }).catch(error => {
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * このモーダルを閉じる処理
         * ---------------------------------------------- */
        closeModal () {
            this.$emit('close', ['benefits_count', this.count]);
        },
        /** ----------------------------------------------
         * 特典入力欄を表示する処理
         * ---------------------------------------------- */
        openChild () {
            this.propsBenefitGolfCourse = this.benefitGolfCourse;
            this.benefitDialog = true;
        },
        /** ----------------------------------------------
         * 特典入力欄を閉じる処理
         * ---------------------------------------------- */
        closeChild () {
            this.benefitDialog = false;
            this.desserts.splice(0, this.desserts.length);
            this.propsBenefitGolfCourse = '';
            this.getBenefitList();
        },
        /** --------------------------------------------
        * ページネーション処理
        * -------------------------------------------- */
        clickPagination () {
            this.beginRow = this.page * this.limitRows - this.limitRows;
            this.getBenefitList();
        },
        /** ----------------------------------------------
         * 削除ダイアログを表示する
         * ---------------------------------------------- */
        displayRemoveOverLay (item) {
            this.benefitCd = item.benefit_cd;
            this.removeOverlay = true;
        },
        /** ----------------------------------------------
         * 削除ダイアログを閉じる
         * ---------------------------------------------- */
        closeRemoveOverLay (item) {
            this.process.result = '';
            this.removeOverlay = false;
        }
    }
};
</script>
